import * as React from 'react';
import { default as ListCore, } from '@core-front/list';
function BEM(props) {
    const classArray = [];
    if (props.numberSize) {
        classArray.push('list--number-size-' + props.numberSize);
    }
    if (props.theme) {
        classArray.push('list--theme-' + props.theme);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const List = (props) => {
    return (React.createElement(ListCore, Object.assign({}, props, { className: BEM(props) })));
};
export { List as default, };
